module.exports = __webpack_public_path__ + "static/media/schoolbus2.f55345ad.mov";